import React, {useCallback, useEffect, useMemo, useState} from "react"
import PropTypes from "prop-types"
import {Stack} from "@mui/material"
import {RoutineService} from "src/services/routine-service"
import {dispatchSnackbar} from "src/v2/components/SnackBar/snackbar-bus"
import {buildDailyReportTable, decodeResponsePayload} from "../report-data"
import ReportTable from "./report-table"

const DailyReportTab = ({active, onLoadingChange}) => {
    const service = useMemo(() => new RoutineService(), [])
    const [loading, setLoading] = useState(false)
    const [table, setTable] = useState({rows: [], columns: []})

    const load = useCallback(async () => {
        setLoading(true)
        onLoadingChange(true)
        try {
            const response = await service.startarRelatorioTabelaCalculo()
            const result = buildDailyReportTable(decodeResponsePayload(response))
            setTable(result)
            if (result.rows.length === 0) dispatchSnackbar("Nenhum dado disponível", "info")
        } catch (_) {
            dispatchSnackbar("Erro ao carregar o relatório noturno", "error")
        } finally {
            setLoading(false)
            onLoadingChange(false)
        }
    }, [onLoadingChange, service])

    useEffect(() => {
        if (active) load()
        return () => onLoadingChange(false)
    }, [active, load, onLoadingChange])

    return (
        <Stack spacing={3} sx={{pt: 3}}>
            <ReportTable
                title="Relatório das rotinas noturnas"
                rows={table.rows}
                columns={table.columns}
                loading={loading}
                onRefresh={load}
            />
        </Stack>
    )
}

DailyReportTab.propTypes = {
    active: PropTypes.bool,
    onLoadingChange: PropTypes.func.isRequired,
}

export default DailyReportTab
